module.exports = __webpack_public_path__ + "img/dd97b60.jpg";